const GLOBAL_SHORTCUTS = [
    {
        combo: 'alt+shift+k',
        action: 'Open shortcuts help',
        description: 'Show keyboard shortcuts for the current page.',
    },
]

const ROUTE_SHORTCUTS = {
    dashboard: [
        {
            combo: 'alt+shift+r',
            handler: 'reset_search',
            action: 'Reset search',
            description: 'Clears current dashboard search state and results.',
        },
        {
            combo: 'alt+shift+q',
            handler: 'open_quote_modal',
            predicate: 'can_open_quote_modal',
            action: 'Quote modal open/toggle size',
            description: 'Opens quote modal when closed, and toggles minimize/maximize when open.',
        },
        {
            combo: 'alt+shift+1..9',
            action: 'Select part by index',
            description: 'Selects part #1 to #9 when that index exists in the current search.',
        },
    ],
    'my-quotes': [
        {
            combo: 'alt+shift+r',
            handler: 'reset_filters',
            action: 'Reset filters',
            description: 'Resets quote list filters.',
        },
        {
            combo: 'alt+shift+s',
            handler: 'search_quotes',
            action: 'Search',
            description: 'Runs quote list search with current filters.',
        },
        {
            combo: 'alt+shift+a',
            handler: 'search_again',
            predicate: 'has_single_selection_with_rows',
            action: 'Search Again',
            description: 'Requires exactly one selected quote row.',
        },
        {
            combo: 'alt+shift+v',
            handler: 'view_resume',
            predicate: 'has_single_selection_with_rows',
            action: 'View / Resume',
            description: 'Requires exactly one selected quote row.',
        },
        {
            combo: 'alt+shift+d',
            handler: 'download_quotes',
            predicate: 'has_any_selection_with_rows',
            action: 'Download',
            description: 'Requires one or more selected quote rows.',
        },
    ],
}

const ROUTE_TITLES = {
    dashboard: 'Dashboard Shortcuts',
    'my-quotes': 'My Quotes Shortcuts',
}

export function getShortcutHelpForRoute(routeName) {
    const routeItems = ROUTE_SHORTCUTS[routeName] || []
    const title = ROUTE_TITLES[routeName] || 'Page Shortcuts'

    return {
        title,
        items: [...GLOBAL_SHORTCUTS, ...routeItems],
    }
}

export function getRouteShortcutRuntime(routeName, { handlers = {}, predicates = {} } = {}) {
    const routeItems = ROUTE_SHORTCUTS[routeName] || []

    const bindings = routeItems
        .filter((item) => item.combo && item.handler)
        .map((item) => ({
            combo: item.combo,
            when: item.predicate ? () => Boolean(predicates[item.predicate]?.()) : undefined,
            action: () => handlers[item.handler]?.(),
        }))
        .filter((item) => typeof item.action === 'function')

    return { bindings }
}
